import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import theme from ".";
import { ChakraProvider, createStandaloneToast } from "@chakra-ui/react";
export function CartridgeUIProvider({ children, }) {
    const { ToastContainer } = createStandaloneToast();
    return (_jsxs(ChakraProvider, { theme: theme, children: [children, _jsx(ToastContainer, {})] }));
}
//# sourceMappingURL=Provider.js.map